/**
 * @documental
 * @export useInputReadonly
 * @import
 * import { useInputReadonly } from "capitalrx-components-2.0/lib/forms";
 */

import { useContext } from "react";
import { InputGroupContext } from "./InputGroupContext";
import { InputProps } from "./InputProps";

/**
 * Returns whether the input should be read-only. The `InputGroup`'s `readonly` property only takes into effect if the input
 * does not explicitly have a read-only state set.
 * @param props The input base properties.
 * @returns Whether the input should be read-only.
 */
export function useInputReadonly(props: InputProps): boolean {
  const { readOnly } = props;
  const { readOnly: groupReadOnly } = useContext(InputGroupContext);

  if (readOnly === undefined) return groupReadOnly;

  return readOnly;
}
